import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const scores = {
    top_scores: "Топ 15 по общей статистике",
    top_explosives: "Топ 15 рейдеров",
    top_resources: "Топ 15 по фарму ресурсов",
    top_npc: "Топ 15 убийц NPC",
    top_animal: "Топ 15 охотников на зверей",
    top_times: "Топ 15 по времени в игре",
};

const tabNames = {
    top_scores: "Общий рейтинг",
    top_explosives: "Рейдеры",
    top_resources: "Фармеры",
    top_npc: "Убийцы NPC",
    top_animal: "Охотники",
    top_times: "Время в игре",
};

const ServerRating = ({ stats, selectedTab, onTabChange }) => (
    <Box>
        <Typography variant="h6" component="h2" gutterBottom>
            Достижения игроков, обновляются несколько раз в сутки
        </Typography>
        <Tabs
            value={selectedTab}
            onChange={(event, newValue) => onTabChange(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ mb: 2 }}
        >
            {Object.entries(tabNames).map(([key, label]) => (
                <Tab key={key} label={label} value={key} />
            ))}
        </Tabs>

        {Object.entries(stats || {}).map(([key, entries]) => {
            if (selectedTab !== key) return null;

            return (
                <Box key={key} sx={{ mt: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                        {scores[key]}
                    </Typography>
                    <Box
                        component="table"
                        sx={{
                            width: "100%",
                            borderCollapse: "collapse",
                            borderRadius: 1,
                            overflow: "hidden",
                            backgroundColor: "background.paper",
                        }}
                    >
                        <thead>
                            <tr>
                                <th style={{ padding: 8, textAlign: "left", borderBottom: "1px solid #444", width: "50%" }}>
                                    Игрок
                                </th>
                                <th style={{ padding: 8, textAlign: "left", borderBottom: "1px solid #444" }}>Score</th>
                                {entries[0] && "Bonus" in entries[0] && (
                                    <th style={{ padding: 8, textAlign: "left", borderBottom: "1px solid #444" }}>Бонусы</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {entries.map((entry, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? "#464c4c" : "#525959",
                                        transition: "background-color 0.2s",
                                    }}
                                    onMouseEnter={(event) => {
                                        event.currentTarget.style.backgroundColor = "#3f4949";
                                    }}
                                    onMouseLeave={(event) => {
                                        event.currentTarget.style.backgroundColor = index % 2 === 0 ? "#464c4c" : "#525959";
                                    }}
                                >
                                    <td style={{ padding: 8 }}>{entry.Name}</td>
                                    <td style={{ padding: 8 }}>{entry.Score}</td>
                                    {"Bonus" in entry && <td style={{ padding: 8 }}>{entry.Bonus > 0 ? entry.Bonus : ""}</td>}
                                </tr>
                            ))}
                        </tbody>
                    </Box>
                </Box>
            );
        })}
    </Box>
);

export default ServerRating;
